import React from 'react';
import PublicLayout from '../../layout/PublicLayout';
import ForgotPasswordContainer from '../../containers/ForgotPassword';

export default function ForgotPassword() {
  return (
    <PublicLayout>
      <ForgotPasswordContainer />
    </PublicLayout>
  );
}
